import { BrowserRouter as Router } from "react-router-dom"
import ThemeProvider from "@mui/material/styles/ThemeProvider"
import CssBaseline from "@mui/material/CssBaseline"

import { DEFAULT_THEME } from "helpers/utils/constants"
import { getTheme } from "styles/themes"
import Routes from "features/Routes"
import SnackbarProvider from "widgets/snackbars/SnackbarProvider"

function App() {
  // Theme switching is disabled for now; force the default (dark) theme
  // regardless of any previously persisted preference. To re-enable user
  // theme switching, restore `getTheme(useSelector(selectTheme))`.
  const theme = getTheme(DEFAULT_THEME)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <SnackbarProvider>
          <Routes />
        </SnackbarProvider>
      </Router>
    </ThemeProvider>
  )
}

export default App
